import { NavLink } from "react-router-dom";
import './Home.css'
import { HelpAbility } from "helpers/HelpAbility";
import C from "helpers/HelpConstants";

const DatosV8 = () => {
    let myAbilities = HelpAbility();
    return (
        <div className="container">
            <div className="row no-gutters my-md-4">
                <div className="col-md-12 col-xs-12 ">
                    <h4 className="text-center" style={{ color: '#009CDD' }}>Bienvenidos al Sistema de</h4>
                    <h2 className="text-center text-uppercase" style={{ color: '#009CDD' }}>Administración de
                        Datos V8</h2>
                    <div className="row">
                        {(myAbilities.has(C.A.PRODUCT.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/products">
                                <div className="card card-custom">
                                    <img src="/img/product.png" className="card-img-top card-img-top-custom mx-auto"
                                        alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Productos</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                        {(myAbilities.has(C.A.CUSTOMER.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/clients">
                                <div className="card card-custom">
                                    <img src="/img/client.png" className="card-img-top card-img-top-custom mx-auto"
                                        alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Clientes</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                        {(myAbilities.has(C.A.LINE.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/lines">
                                <div className="card card-custom">
                                    <img src="/img/telephone-line.png"
                                        className="card-img-top card-img-top-custom mx-auto"
                                        alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Lineas</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                        {(myAbilities.has(C.A.USER.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/users">
                                <div className="card card-custom">
                                    <img src="/img/user.png" className="card-img-top card-img-top-custom mx-auto"
                                        alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Usuarios</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                        {(myAbilities.has(C.A.DEPARTAMENT.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/departaments">
                                <div className="card card-custom">
                                    <img src="/img/departament.png" className="card-img-top card-img-top-custom mx-auto"
                                        alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Departamentos y Ciudades</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                        {(myAbilities.has(C.A.CENTER.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/centers">
                                <div className="card card-custom">
                                    <img src="/img/center.png" className="card-img-top card-img-top-custom mx-auto"
                                        alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Centros y Agentes</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.DIRECTION.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/directions">
                                <div className="card card-custom">
                                    <img src="/img/directions.png" className="card-img-top card-img-top-custom mx-auto"
                                        alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Direcciones</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.ORGANIZACION.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/organization">
                                <div className="card card-custom">
                                    <img src="/img/directions.png" className="card-img-top card-img-top-custom mx-auto"
                                        alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Organizaciones</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.EMAIL.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/emails">
                                <div className="card card-custom">
                                    <img src="/img/emails.png" className="card-img-top card-img-top-custom mx-auto"
                                        alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Correos</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.FLUJOSSTRUCTURE.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/flujos-estructure">
                                <div className="card card-custom">
                                    <img src="/img/flows.png" className="card-img-top card-img-top-custom mx-auto"
                                        alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Flujos Estructure</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.NIVELESSTRUCTURE.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/niveles">
                                <div className="card card-custom">
                                    <img src="/img/flows.png" className="card-img-top card-img-top-custom mx-auto"
                                        alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Niveles Flujos</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}

                        {(myAbilities.has(C.A.FLUJOSADDRESSCOMPLEMENT.LIST) && myAbilities.hasRol(C.R.DESARROLLADOR)) && <div className="col-sm-2">
                            <NavLink exact className="nav-link nav-link-custom" to="/flujos-address-complement">
                                <div className="card card-custom">
                                    <img src="/img/flows.png" className="card-img-top card-img-top-custom mx-auto"
                                        alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title text-center">Flujos Address Complement</h6>
                                    </div>
                                </div>
                            </NavLink>
                        </div>}
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <p><strong>Objetivo Principal</strong></p>
                            <p>Consolidar conocimientos en ReactJs y NodeJs</p>
                            <p><strong>Objetivos Especificos</strong></p>
                            <ul>
                                <li>Gestionar los parámetros de los servicios registrados</li>
                                <li>Gestionar Permisos para la administración de servicios</li>
                            </ul>
                        </div>
                        {false && <div className="col-sm-6">
                            <p><strong>Próximamente...</strong></p>
                            <ul>
                                <li>Gestión de Clientes</li>
                                <li>Gestión de Lineas</li>
                                <li>Gestión de Permisos</li>
                            </ul>
                        </div>}
                    </div>
                </div>

                <div className="col-md-12 col-xs-12 ">
                    <div className="row">
                        <div className="col-sm-6">
                            <p className="text-center"><strong>Arquitectura Inicial</strong></p>
                            <img src="/img/AS-IS.PNG" className="img-fluid-noexiste" alt="Arquitectura Inicial" />
                        </div>
                        <div className="col-sm-6">
                            <p className="text-center"><strong>Arquitectura Actual</strong></p>
                            <img src="/img/TO-BE.PNG" className="img-fluid-noexiste" alt="Arquitectura Actual" />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
export default DatosV8;